import React from 'react';
import { Wrapper as GoogleMapsWrapper } from '@googlemaps/react-wrapper';

const CrystalMapWrapper = ({ children }) => {
  return (
    <GoogleMapsWrapper
      libraries={['geometry', 'places']}
      apiKey={window.googleMapsApiKey}
    >
      {children}
    </GoogleMapsWrapper>
  );
};

export default CrystalMapWrapper;
